import type { CustomersAPIInterface } from '~/interfaces/api/customer.interfaces'
import { API_CUSTOMER_GET } from '~/constants/routes/api/customer/routes.constants'

export const getCustomersRepository = async (page: number, limit: number, name?: string, enabled?: number, status?: number): Promise<CustomersAPIInterface> => {
  const query = {}

  if (name) {
    Object.assign(query, {
      'filters[search]': name
    })
  }
  if (enabled) {
    Object.assign(query, {
      'filters[is_enabled]': enabled
    })
  }
  if (status) {
    Object.assign(query, {
      'filters[active]': status
    })
  }

  return await useCustomFetch<CustomersAPIInterface>(API_CUSTOMER_GET.path, {
    query
  }, page, limit)
}
